<template>
  <div>
    <a-table :columns="columns" :dataSource="dataSource" class="c-table">
      <span slot="id"></span>
      <span slot="name"></span>
      <span slot="teacher"></span>
      <span slot="count"></span>
      <span slot="age"></span>
      <span slot="address"></span>
    </a-table>
  </div>
</template>
<script>
const columns = [
  {
    title: '课程号',
    dataIndex: 'id',
    key: 'id',
  },
  {
    title: '课程名',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: '老师',
    dataIndex: 'teacher',
    key: 'teacher',
  },
  {
    title: '人数',
    dataIndex: 'count',
    key: 'count',
  },
  {
    title: '年龄',
    dataIndex: 'age',
    key: 'age',
  },
  {
    title: '住址',
    dataIndex: 'address',
    key: 'address',
  },
];

export default {
  name: 'CTable',
  data(){
    return{
      columns,
      dataSource: [],
    }
  },
  mounted(){
    for(let i = 0 ; i < 10 ; i++){
      this.dataSource.push({
        key: i,
        id: '8432',
        name: '3D打印机',
        teacher: '古老师',
        count: '32',
        age: 25,
        address: '西湖区湖底公园1号',
      })
    }
  }

}
</script>
<style lang="scss" scoped>
@import 'src/config/var';
  .c-table{
    min-width: calc(100% - 40px);
    margin: 20px 0px;
    padding: 20px 0px;
  }
  
</style>
